import { isVNode, Comment, Fragment } from 'vue';

import type { Slots, VNodeArrayChildren, VNode } from 'vue';

/**
 * Render slot with props and fallback (Instead of renderSlot function from Vue 3)
 * @param slots
 * @param name
 * @param props
 * @param fallback
 */
export function customRenderSlot(
  slots: Slots,
  name: string,
  props: Record<string, unknown>,
  fallback?: () => VNodeArrayChildren
): VNode {
  const slot = slots[name]?.(props);

  if (ensureValidVNode(slot!)) {
    return slot as unknown as VNode;
  }

  return fallback?.() as unknown as VNode;
}

function ensureValidVNode(slot: VNodeArrayChildren | null): VNodeArrayChildren | null {
  return (slot || []).some((child) => {
    if (!isVNode(child)) return true;
    if (child.type === Comment) return false;
    return !(child.type === Fragment && !ensureValidVNode(child.children as VNodeArrayChildren));
  })
    ? slot
    : null;
}
